import type { SubAsset } from '@/common/sub-asset';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetSubAssetSuccessResponseType = SubAsset;

export async function updateSubAsset(
	id: string,
	subAssetPayload: Omit<SubAsset, 'id'>,
): Promise<GetSubAssetSuccessResponseType | null> {
	const response = await axios.patch(`${API_URLS.SUB_ASSETS.INDEX}/${id}`, subAssetPayload);
	return getResponse<GetSubAssetSuccessResponseType>(response.data);
}
